import ModelUtil from '@leverege/model-util';
import { ns } from '@leverege/i18n';
const TYPE = 'graph.background.image';

// https://recovr-ui-assets.storage.googleapis.com/logo-login.png

const {
  t,
  tf
} = ns('ui-attributes-graphs.models.ImageGraphBackgrounModel');
function create() {
  return {
    type: TYPE,
    backgroundColor: null,
    image: {
      url: null,
      height: null,
      width: null,
      x: null,
      y: null,
      opacity: 100
    }
  };
}
export default {
  create,
  TYPE,
  get name() {
    return t('name');
  },
  ...ModelUtil.createAllValue('backgroundColor'),
  ...ModelUtil.createAllValue('image/url', 'imageUrl'),
  ...ModelUtil.createAllValue('image/height', 'imageHeight'),
  ...ModelUtil.createAllValue('image/width', 'imageWidth'),
  ...ModelUtil.createAllValue('image/x', 'imageX'),
  ...ModelUtil.createAllValue('image/y', 'imageY'),
  ...ModelUtil.createAllValue('image/opacity', 'imageOpacity')
};